import React, { Component } from "react";

import { Card, Loader } from 'semantic-ui-react'
import { injectIntl, defineMessages, FormattedMessage, } from "react-intl";
import CreationCardView from "../StoryView/StoryCardView";


import "./StoriesList.css";
import deepknitLogoanimated from "../StoriesMenu/images/deepknitanimated.svg"

import { Grid } from "semantic-ui-react";
import { Segment } from "semantic-ui-react";
import { Dimmer, Image } from "semantic-ui-react";

const messages = defineMessages({
    found: {
        id: 'app.stories.gender',
        defaultMessage: 'Gender'
    }
})

class StoriesList extends Component {


    render() {
        const { intl: { formatMessage } } = this.props;
        const { stories } = this.props;

        return (
            <div className="StoriesList">
                {/* <Dimmer active inverted>
                    <Image src={deepknitLogoanimated} />
                </Dimmer> */}
                {
                    <Grid
                        columns={2} doubling stackable className="masonry"
                    >{
                            stories.map((story) => {
                                return <Grid.Column><CreationCardView key={story._id} story={story} /></Grid.Column>
                            })
                        }
                    </Grid>
                }
            </div>

        )
    }
}

export default injectIntl(StoriesList)